<!-- <template>
  <nuttrema-layout-content>
    <router-view slot="overflow"></router-view>

    <my-preferences-standard-header
       slot="header"
      :meta="meta"
      :edit.sync="edit"
      :PersonalProfile="PersonalProfile">
      <template slot="options">
        <el-dropdown-item>
          <a @click="goto('my-preferences-verify-email')">
            {{ $t('label.verify_email') }}
          </a>
        </el-dropdown-item>
      </template>
    </my-preferences-standard-header>

    <template slot="central">
      <nuttrema-loader v-if="PersonalProfile.fetching"></nuttrema-loader>
      <form-personal-change-email
         v-else
        :edit.sync="edit"
        :PersonalEmailChange="PersonalEmailChange"
        :PersonalProfile="PersonalProfile"
        @submit="onSubmitForm">
      </form-personal-change-email>
    </template>
  </nuttrema-layout-content>
</template> -->

<script>
import { mapActions } from 'vuex';

import PageProps from 'components/mixins/page-props';
import Emitter from 'components/mixins/emitter';

import FormPersonalChangeEmail from './form-personal-change-email';

export default {
  name: 'page-personal-change-email',
  mixins: [
    Emitter,
    PageProps,
  ],
  components: {
    FormPersonalChangeEmail,
  },
  data() {
    return {
      edit: false,
    };
  },
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
    PersonalEmailChange() {
      return this.$store.getters.PersonalEmailChange;
    },
  },
  methods: {
    ...mapActions([
      'MakePersonalEmailChange',
    ]),
    onSubmitForm(payload) {
      return this.MakePersonalEmailChange({ payload })
        .then(() => {
          this.successNotification({ message: 'message.confirmation_email_send' });
          this.resetChangeEmailForm();
        }).catch(() => {
          this.errorNotification();
        });
    },
    resetChangeEmailForm() {
      this.broadcast('FormPersonalChangeEmail', 'reset');
    },
    goto(route) {
      this.$router.push({ name: route });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/shared/change-email/page-personal-change-email.vue